module.exports = __webpack_public_path__ + "static/bcspca-logo-8c59f785e442a8c5ed8d79e042f24a87.png";